'use client';
import { ClickAwayListener } from '@mui/material';
import { ReactNode, useCallback, useState, forwardRef, useImperativeHandle } from 'react';

const defaultKey = Date.now();

type RenderProp = (onClose?: () => void) => ReactNode;

interface Props extends React.PropsWithChildren {
  render: RenderProp;
  onClose?(): void;
}

export const QuickSearchContainer = forwardRef<{ reset: () => void }, Props>(
  ({ render, onClose: _onClose }, ref) => {
    const [widgetKey, setWidgetKey] = useState<number>(defaultKey);
    // For handle closing the widget from parent component
    useImperativeHandle(ref, () => ({
      reset() {
        setWidgetKey(Date.now());
      },
    }));

    // For handle parent close state from child component
    const onClose = useCallback(() => {
      setWidgetKey(Date.now());
      if (_onClose) {
        _onClose();
      }
    }, [_onClose]);

    return (
      <ClickAwayListener onClickAway={onClose} touchEvent={false}>
        <div key={widgetKey}>{render(onClose)}</div>
      </ClickAwayListener>
    );
  }
);
